export default __webpack_public_path__ + "static/media/about-us-image.9d9cdb9e.png";